// 动态渲染本地资源图片，并区分在线图片和本地图片
export const getAssetsFile = (url: string) => {
    return /^http/.test(url) ? url : require(`@/assets/${url}`)
}